import React from 'react';

import PropTypes from 'prop-types';

import { CONTENT_BY_TYPE } from './EnterAddressManuallyPrompt.constants';

import './EnterAddressManuallyPrompt.css';

const propTypes = {
  onSelectNoResults: PropTypes.func,
  types: PropTypes.string.isRequired,
};

const defaultProps = {
  onSelectNoResults: () => null,
};

export default function EnterAddressManuallyPrompt({ onSelectNoResults, types }) {
  return (
    <div
      className="enter-address-manually-prompt content"
      onKeyDown={onSelectNoResults}
      onClick={onSelectNoResults}
      role="button"
      tabIndex={-1}
    >
      {CONTENT_BY_TYPE[types]}
    </div>
  );
}

EnterAddressManuallyPrompt.propTypes = propTypes;
EnterAddressManuallyPrompt.defaultProps = defaultProps;
